<template>
  <div class="notification">
    <div class="notification-content">
      <div class="notification-image">
        <img v-if="isMobile && mobileNotificationImage" :src="mobileNotificationImage" />
        <img v-else :src="notificationImage" />
      </div>
      <div class="notification-message">
        <h3>{{ notificationTitle }}</h3>
        <p>{{ notificationMessage }}</p>
      </div>
    </div>
    <div class="notification-cta-wrapper" v-if="ctaButton">
      <a class="notification-cta-button" :href="ctaButton.link">{{ ctaButton.text }}</a>
    </div>
    <div class="notification-close" @click="$emit('closeNotification', notification.MessageId)">
      <div class="notification-close-button"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Notification',
  props: {
    notification: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
    }),
    ctaButton() {
      if ((typeof this.notification.CTAButtonText === 'undefined' || this.notification.CTAButtonText === '')) return null;
      if ((typeof this.notification.CTAButtonLink === 'undefined' || this.notification.CTAButtonLink === '')) return null;

      const link = this.notification.CTAButtonLink;
      return { text: this.notification.CTAButtonText, link };
    },
    notificationTitle() {
      if (!this.notification) return '';
      let title = this.notification.Title;
      // TODO
      // title = title.replace(/href="(?:{{|{)([^{|"|}]*)(?:}}|})/gi, this.GetCorrectFullLink);
      if (!this.notification.Data) return title;

      Object.keys(this.notification.Data).forEach((key) => {
        title = title.replace(`{${key}}`, this.notification.Data[key]);
      });

      return title;
    },
    notificationMessage() {
      if (!this.notification) return '';
      if (!this.notification.Message) return '';
      let message = this.notification.Message;

      // TODO
      // message = message.replace(/href="(?:{{|{)([^{|"|}]*)(?:}}|})/gi, this.GetCorrectFullLink);
      if (!this.notification.Data) return message;

      Object.keys(this.notification.Data).forEach((key) => {
        message = message.replace(`{${key}}`, this.notification.Data[key]);
      });

      return message;
    },
    notificationImage() {
      if (!this.notification) return '';
      if (!this.notification.ImageUrl || this.notification.ImageUrl === '') {
        if (this.notification.Data.Image) return this.notification.Data.Image;
        return '';
      }

      let imageUrl = this.notification.ImageUrl;

      if (!this.notification.Data) return imageUrl;

      Object.keys(this.notification.Data).forEach((key) => {
        imageUrl = imageUrl.replace(`{${key}}`, this.notification.Data[key]);
      });
      return imageUrl;
    },
    mobileNotificationImage() {
      if (!this.notification) return '';
      if (!this.notification.MobileImageUrl || this.notification.MobileImageUrl === '') {
        if (this.notification.Data.MobileImage) return this.notification.Data.MobileImage;
        return '';
      }

      let mobileImageUrl = this.notification.MobileImageUrl;

      if (!this.notification.Data) return mobileImageUrl;

      Object.keys(this.notification.Data).forEach((key) => {
        mobileImageUrl = mobileImageUrl.replace(`{${key}}`, this.notification.Data[key]);
      });
      return mobileImageUrl;
    },
  },
};
</script>

<style lang="less" scoped>
@import (css) url('https://fonts.googleapis.com/css?family=Lato|Lilita+One');

.notification {
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  width: 400px;
  border-radius: 20px;
  margin-bottom: 30px;
  box-shadow: 0px 0px 12px #333;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 0;
    padding-bottom: 30px;
    border-radius: 0;

    .notification-close {
      display: none;
    }

    &:last-child {
      .notification-close {
        display: block;
      }
    }
  }
}

.notification-image {
  margin-right: 10px;
}

.notification-image img {
  max-width: 60px;
}

.notification-message h3 {
  margin: 0;
  margin-top: 5px;

  font-family: 'Lilita One', cursive;
  font-size: 17px;
  line-height: normal;
  font-weight: 100;
  color: #f69f37;
  text-transform: uppercase;
}

.notification-message p {
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 22px;
  color: #287a84;
}

.notification-message p {
  margin: 0;
}

.notification-cta-wrapper {
  text-align: center;

  @media (min-width: 768px) {
    text-align: right;
  }
}

.notification-cta-button {
  color: #fff;
  background-color: #4ace5f;
  font-family: 'Lilita One', cursive;
  font-size: 17px;
  line-height: normal;
  font-weight: 100;
  border-radius: 30px;
  display: inline-block;
  padding: 10px 50px;
  text-decoration: none;
  text-transform: uppercase;
}

.notification-content {
  display: flex;
}

.notification-close {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);

  @media (min-width: 768px) {
    bottom: auto;
    left: auto;
    transform: none;
    top: 0;
    right: -5px;
    transform: translateY(-35%);
  }
}

.notification-close {
  background-color: #d64572;
  color: #fff;
  display: inline-block;
  height: 40px;
  width: 40px;
  border-radius: 50%;

  &:after,
  &:before {
    content: '';
    position: absolute;
    background-color: #fff;
    width: 60%;
    height: 5px;
    border-radius: 3px;
    display: block;
    left: 50%;
    top: 50%;
  }

  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
    transform-origin: center;
  }

  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
}
</style>
